import React from 'react';

// Données pour les étapes
const steps = [
  {
    id: 1,
    icon: "/home-7/about/icons/1.svg",
    title: "Modules ludiques & pratiques",
    description: "VR, robotique, design 3D, IoT, électronique."
  },
  {
    id: 2,
    icon: "/home-7/about/icons/2.svg",
    title: "Kits projets inclus",
    description: "Chaque module = un projet concret à réaliser chez soi + au lab."
  },
  {
    id: 3,
    icon: "/home-7/about/icons/3.svg",
    title: "Progression accompagnée",
    description: "Sessions 1:1 régulières avec de jeunes tuteurs + un forum collaboratif pour échanger, progresser et s'entraider entre pairs."
  }
];

const UniqueLearningAdventure = () => {

  return (
    <section className="bg-white py-12 md:py-16 lg:py-24 flex-1 dark:bg-gray-900">
      <div className="container mx-auto px-6 md:px-20">
        <div className="flex flex-col lg:flex-row justify-between items-center">
          {/* Image Section - maintenant en premier sur mobile */}
          <div className="lg:w-6/12 order-1 mb-10 lg:mb-0 lg:order-2 relative">
            <div className="relative flex flex-col items-center lg:block">
              {/* Main Images - version mobile empilée */}
              <div className="relative z-10 flex flex-col items-center space-y-8 lg:space-y-0 lg:block">
                {/* Première image */}
                <div className="h-[250px] w-[250px] md:h-[350px] md:w-[350px] lg:h-[540px] lg:w-[540px]">
                  <img 
                    src="/home-7/about/1.png" 
                    alt="Learning process"
                    className="w-full h-full rounded-full object-cover"
                  />
                </div>
                
                {/* Deuxième image - positionnée différemment sur mobile */}
                <div className="h-[180px] w-[180px] md:h-[250px] md:w-[250px] lg:absolute lg:top-3/4 lg:left-1/4 lg:transform lg:-translate-x-[59%] lg:-translate-y-[15%] lg:h-[330px] lg:w-[330px]">
                  <img 
                    src="/home-7/about/2.png" 
                    alt="Learning process"
                    className="w-full h-full rounded-full object-cover"
                  />
                </div>
              </div>

              {/* Floating Elements - adaptés pour mobile */}
              <div className="lg:absolute lg:top-5 lg:left-28 z-20 mt-6 lg:mt-0">
                <div className="bg-white p-4 lg:p-5 w-full lg:w-[290px] h-auto lg:h-[90px] rounded-xl flex items-center shadow-md lg:shadow-none">
                  <div className="bg-red-100 p-2 lg:p-3 rounded-full">
                    <img 
                      src="/masthead/1.svg" 
                      alt="Free courses" 
                      className="w-5 h-5 lg:w-6 lg:h-6"
                    />
                  </div>
                  <div className="ml-4 lg:ml-5">
                    <div className="text-red-1 text-sm lg:text-base">3.000 +</div>
                    <div className="text-gray-600 dark:text-gray-400 text-xs lg:text-sm">Cours gratuits</div>
                  </div>
                </div>
              </div>

              <div className="lg:absolute lg:top-[55%] lg:-left-20 z-20 mt-6 lg:mt-0">
                <div className="bg-white p-4 lg:p-5 w-full lg:w-[290px] h-auto lg:h-[90px] rounded-xl flex items-center shadow-md lg:shadow-none">
                  <div className="bg-purple-1 p-2 lg:p-3 rounded-full">
                    <img 
                      src="/masthead/2.svg"
                      alt="Admission" 
                      className="w-5 h-5 lg:w-6 lg:h-6"
                    />
                  </div>
                  <div className="ml-4">
                    <div className="text-purple-1 text-sm lg:text-base">Félicitations !</div>
                    <div className="text-gray-600 dark:text-gray-400 text-xs lg:text-sm">Votre admission complétée</div>
                  </div>
                </div>
              </div>

              <div className="lg:absolute lg:-bottom-12 lg:right-7 z-20 mt-6 lg:mt-0">
                <div className="bg-white p-4 lg:p-5 w-full lg:w-[290px] h-auto lg:h-[90px] rounded-xl flex items-center shadow-md lg:shadow-none">
                  <img 
                    src="/masthead/4.png" 
                    alt="Ali Tufan"
                    className="w-10 h-10 lg:w-12 lg:h-12 rounded-full"
                  />
                  <div className="ml-4">
                    <div className="text-dark-1 text-sm lg:text-base">Ali Tufan</div>
                    <div className="text-gray-600 dark:text-gray-400 text-xs lg:text-sm">Mentor</div>
                    <div className="flex mt-1">
                      {[...Array(5)].map((_, i) => (
                        <svg key={i} className="w-3 h-3 lg:w-4 lg:h-4 text-yellow-400 fill-current" viewBox="0 0 20 20">
                          <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                        </svg>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Content Section - maintenant en deuxième position sur mobile */}
          <div className="lg:w-5/12 order-2 lg:order-1">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-dark-1 mb-8 lg:mb-12 text-center lg:text-left">
              Une aventure d'apprentissage <span className="text-purple-1">unique</span>
            </h2>

            {/* Steps */}
            <div className="space-y-6 lg:space-y-8">
              {steps.map((step) => (
                <div key={step.id} className="flex items-start">
                  <div className="flex-shrink-0 bg-light-2 p-3 lg:p-4 rounded-full">
                    <img 
                      src={step.icon} 
                      alt={step.title} 
                      className="w-8 h-8 lg:w-10 lg:h-10 object-contain"
                    />
                  </div>
                  <div className="ml-4 lg:ml-6">
                    <h4 className="text-base lg:text-lg text-dark-1">
                      {step.title}
                    </h4>
                    <p className="text-gray-600 text-xs lg:text-sm mt-1 lg:mt-2">
                      {step.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default UniqueLearningAdventure;